import {barnManagerModule} from './index.module';

barnManagerModule.config(['$locationProvider', ($locationProvider) => {
  $locationProvider.hashPrefix('');
  $locationProvider.html5Mode(true);
} ]);
